import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const getFunctionsAll = createAsyncThunk("user/getFunctionsAll", async (payload) => {

  const response = await api.post("admin/functions/get-all", payload);
 
  return response.data;
});

const getFunctionsAllSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
//   middleware: (getDefaultMiddleware) =>
//   getDefaultMiddleware({
//     serializableCheck: {
//       ignoredPaths: ["payload.headers"],
//     },
//   }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFunctionsAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFunctionsAll.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getFunctionsAll.rejected, (state, action) => {
        state.loading = false;
     
        toast.error(action.error.message);
      });
  },
});

export default getFunctionsAllSlice.reducer;
